<template>
	<a-layout style="height: 100vh; overflow: hidden">
		<a-layout-sider v-model="collapsed" collapsible style="height: 100vh; overflow-y: auto; overflow-x: hidden">
			<div class="logo">
				<span v-if="!collapsed">工业气瓶管理系统</span>
				<span v-else>气瓶</span>
			</div>
			<a-menu theme="dark" :selected-keys="[selectedKey]" mode="inline" @click="handleMenuClick">
				<template v-for="menu in menuList">
					<a-menu-item v-if="menu.ismenu && !menu.children && checkPermission(menu.name)"
						:key="`item-${menu.name}`">
						<a-icon :type="menu.icon" />
						<span>{{ menu.title }}</span>
					</a-menu-item>
					<a-sub-menu v-if="menu.ismenu && menu.children && hasPermission(menu)" :key="`sub-${menu.name}`">
						<span slot="title">
							<a-icon :type="menu.icon" />
							<span>{{ menu.title }}</span>
						</span>
						<template v-for="child in menu.children">
							<a-menu-item v-if="child.ismenu && checkPermission(child.name)"
								:key="`child-${child.name}`">
								<a-icon :type="child.icon" />
								<span>{{ child.title }}</span>
							</a-menu-item>
						</template>
					</a-sub-menu>
				</template>
			</a-menu>
		</a-layout-sider>
		<a-layout style="height: 100vh; overflow: hidden">
			<a-layout-header style="background: #fff; padding: 0 24px; flex-shrink: 0">
				<div style="float: right; display: flex; align-items: center; gap: 16px;">
					<span class="enterprise-name">
						<a-icon type="bank" />
						{{ enterpriseDisplayName }}
					</span>

					<!-- 待抄收订单通知入口 -->
					<a-tooltip title="抄收订单" placement="bottom">
						<a-badge :count="ccPendingCount" :overflow-count="99" :offset="[-2, 2]" :show-zero="false">
							<a-button type="text" shape="circle" icon="bell" class="notification-btn"
								@click="handleGoCcList" />
						</a-badge>
					</a-tooltip>
			<!-- 		<a-tooltip v-else title="暂无待抄收订单" placement="bottom">
						<a-button type="text" shape="circle" icon="bell" class="notification-btn"
							style="color: #bfbfbf; cursor: default;" />
					</a-tooltip> -->

					<a-dropdown style="width: 200px;">
						<a class="ant-dropdown-link" @click.prevent>
							<span class="username-text">{{ currentUser ? currentUser.nickname : '管理员' }}</span>
							<a-icon type="down" style="margin-left: 4px;" />
						</a>
						<a-menu slot="overlay" @click="handleDropdownMenuClick">
							<a-menu-item key="profile">个人设置</a-menu-item>
							<a-menu-item key="logout">退出登录</a-menu-item>
						</a-menu>
					</a-dropdown>
				</div>
			</a-layout-header>
			<a-layout-content style="margin: 24px 16px 0; flex: 1; overflow-y: auto; overflow-x: hidden">
				<div style="padding: 24px; background: #fff; min-height: 100%">
					<router-view />
				</div>
			</a-layout-content>
			<a-layout-footer style="text-align: center; flex-shrink: 0">
				工业气瓶管理系统 ©2024 Created by Ant Design Vue
			</a-layout-footer>
		</a-layout>

		<!-- 未抄收订单全局提醒弹窗 -->
		<a-modal v-model="showCcReminderModal" title="待抄收订单提醒" width="720px" :mask-closable="false"
			:body-style="{ maxHeight: '55vh', overflowY: 'auto' }" @ok="handleCcReminderConfirm"
			ok-text="全部标记为已抄收" cancel-text="稍后处理" @cancel="handleCcReminderCancel">
			<a-alert type="warning" show-icon :message="`您有 ${ccPendingList.length} 个待抄收的订单，请及时处理：`"
				style="margin-bottom: 16px;" />
			<a-table :columns="ccReminderColumns" :data-source="ccPendingList" :pagination="false"
				:row-key="record => record.id" size="middle">
				<template slot="confirm_action" slot-scope="text, record">
					<a-button type="link" size="small" @click="handleCcSingleConfirm(record)">确认抄收</a-button>
				</template>
			</a-table>
		</a-modal>

			<!-- 个人设置弹窗 -->
			<a-modal v-model="showProfileModal" title="个人设置" width="520px"
				:body-style="{ maxHeight: '60vh', overflowY: 'auto' }" @ok="handleProfileSave"
				:confirm-loading="profileSaving" ok-text="保存">
				<a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
					<a-form-item label="用户名">
						<a-input v-model="profileForm.username" disabled />
					</a-form-item>
					<a-form-item label="昵称" required>
						<a-input v-model="profileForm.nickname" placeholder="请输入昵称" />
					</a-form-item>
					<a-form-item label="手机号">
						<a-input v-model="profileForm.mobile" placeholder="请输入手机号" maxlength="11" />
					</a-form-item>
					<a-form-item label="邮箱">
						<a-input v-model="profileForm.email" placeholder="请输入邮箱" />
					</a-form-item>
					<a-form-item label="所属企业">
					<a-input :value="enterpriseDisplayName" disabled />
				</a-form-item>
				<a-form-item label="所属部门">
					<a-input :value="(currentUser && currentUser.department_name) || '未分配'" disabled />
				</a-form-item>
				</a-form>
				<a-divider>修改密码（留空则不修改）</a-divider>
				<a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
					<a-form-item label="原密码">
						<a-input-password v-model="profileForm.old_password" placeholder="请输入原密码" />
					</a-form-item>
					<a-form-item label="新密码">
						<a-input-password v-model="profileForm.password" placeholder="请输入新密码" />
					</a-form-item>
					<a-form-item label="确认密码">
						<a-input-password v-model="profileForm.confirm_password" placeholder="请再次输入新密码" />
					</a-form-item>
				</a-form>
			</a-modal>
		</a-layout>
</template>

<script>
import {
	checkPermission
} from '@/utils/permission'
import {
	adminApi,
	productionApi
} from '@/api/auth'

export default {
	name: 'MainLayout',
	data() {
		return {
			collapsed: false,
			selectedKey: 'home',
			currentUser: null,
			menuList: [],
			// 抄送待办相关
			ccPendingCount: 0,
			ccPendingList: [],
			showCcReminderModal: false,
			ccPollingTimer: null,
			ccNotifiedIds: [], // 本轮已弹窗通知过的 production_id，避免重复弹
			ccReminderColumns: [{
					title: '审批编号',
					dataIndex: 'approval_no',
					key: 'approval_no'
				},
				{
					title: '客户名称',
					dataIndex: 'customer_name',
					key: 'customer_name'
				},
				{
					title: '创建人',
					dataIndex: 'creator_name',
					key: 'creator_name'
				},
				{
					title: '创建时间',
					dataIndex: 'create_time',
					key: 'create_time'
				},
				{
					title: '操作',
					key: 'confirm_action',
					scopedSlots: {
						customRender: 'confirm_action'
					}
				}
				],
				// 个人设置
				showProfileModal: false,
				profileSaving: false,
				profileForm: {
					username: '',
					nickname: '',
					mobile: '',
					email: '',
					old_password: '',
					password: '',
					confirm_password: ''
				}
		}
	},
	computed: {
		enterpriseDisplayName() {
			if (!this.currentUser) return ''
			if (this.currentUser.is_super || this.currentUser.enterprise_id === 0) {
				return '超级管理员'
			}
			return this.currentUser.enterprise_name || '未绑定企业'
		}
	},
	watch: {
			$route(to) {
				// 根据路由名称生成正确的key格式
				let isChildMenu = false
				for (const menu of this.menuList) {
					if (menu.children) {
						for (const child of menu.children) {
							if (child.name === to.name) {
								isChildMenu = true
								break
							}
						}
					}
					if (isChildMenu) break
				}
				this.selectedKey = isChildMenu ? `child-${to.name || 'home'}` : `item-${to.name || 'home'}`
			},
			showProfileModal(val) {
				if (val) {
					this.fillProfileForm()
				}
			}
		},
	mounted() {
		// 根据路由名称生成正确的key格式
		// 先检查是否是二级菜单
		let isChildMenu = false
		for (const menu of this.menuList) {
			if (menu.children) {
				for (const child of menu.children) {
					if (child.name === this.$route.name) {
						isChildMenu = true
						break
					}
				}
			}
			if (isChildMenu) break
		}

		this.selectedKey = isChildMenu ? `child-${this.$route.name || 'home'}` : `item-${this.$route.name || 'home'}`
		this.getCurrentUser()
		this.getMenuList()
		console.log('MainLayout mounted, current route:', this.$route.name)
		// 从本地缓存恢复已通知的待抄收订单ID集合，避免刷新页面后弹窗重复出现
		try {
			const cachedIds = localStorage.getItem('ccNotifiedIds')
			this.ccNotifiedIds = cachedIds ? JSON.parse(cachedIds) : []
		} catch (e) {
			this.ccNotifiedIds = []
		}
		// 初始化抄送轮询（首次立即获取，之后30秒一次）
		this.loadCcPendingList()
		this.startCcPolling()
	},
	beforeDestroy() {
		this.stopCcPolling()
	},
	methods: {
		handleMenuClick(e) {
			console.log('Menu clicked:', e)
			// 从key中提取菜单名称
			let menuName = e.key
			if (menuName.startsWith('item-')) {
				menuName = menuName.substring(5)
			} else if (menuName.startsWith('sub-')) {
				menuName = menuName.substring(4)
			} else if (menuName.startsWith('child-')) {
				menuName = menuName.substring(6)
			}

			// 查找对应菜单的URL
			let menuUrl = ''
			for (const menu of this.menuList) {
				if (menu.name === menuName) {
					menuUrl = menu.url
					break
				}
				if (menu.children) {
					for (const child of menu.children) {
						if (child.name === menuName) {
							menuUrl = child.url
							break
						}
					}
				}
			}

			// 根据URL跳转
			if (menuUrl) {
				this.$router.push(menuUrl)
			} else {
				// 回退到原来的方式
				this.$router.push(`/${menuName}`)
			}
		},
		checkPermission(permission) {
			return checkPermission(permission)
		},
		hasPermission(menu) {
			// 检查菜单是否有子菜单有权限
			if (menu.children) {
				for (let child of menu.children) {
					if (this.checkPermission(child.name) && child.type == 'menu') {
						return true
					}
				}
			}
			return false
		},
		async getCurrentUser() {
			const userinfo = localStorage.getItem('userinfo')
			if (userinfo) {
				this.currentUser = JSON.parse(userinfo)
			}
			// 从后端获取最新用户信息（含企业名称）
			try {
				const res = await adminApi.getInfo()
				if (res.code === 1 && res.data.userinfo) {
					this.currentUser = res.data.userinfo
					localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo))
				}
			} catch (e) {
				console.warn('获取用户信息失败:', e.message)
			}
		},
		async getMenuList() {
			try {
				const response = await adminApi.getMenu()
				if (response.code === 1) {
					this.menuList = response.data.menu
					// 检查每个菜单的权限
					this.menuList.forEach(menu => {
						console.log(
							`Menu: ${menu.name}, ismenu: ${menu.ismenu}, has children: ${menu.children ? menu.children.length > 0 : false}`
						)
						console.log(
							`Permission check for ${menu.name}: ${this.checkPermission(menu.name)}`)
						console.log('Menu object:', menu)
					})
				}
			} catch (error) {
				console.error('获取菜单失败:', error)
			}
		},
		handleDropdownMenuClick({ key }) {
						if (key === 'profile') {
							this.showProfileModal = true
						} else if (key === 'logout') {
							this.handleLogout()
						}
					},
					fillProfileForm() {
					if (this.currentUser) {
						this.profileForm.username = this.currentUser.username || ''
						this.profileForm.nickname = this.currentUser.nickname || ''
						this.profileForm.mobile = this.currentUser.mobile || ''
						this.profileForm.email = this.currentUser.email || ''
					}
					this.profileForm.old_password = ''
					this.profileForm.password = ''
					this.profileForm.confirm_password = ''
				},
				resetProfileForm() {
					this.profileForm = {
						username: '',
						nickname: '',
						mobile: '',
						email: '',
						old_password: '',
						password: '',
						confirm_password: ''
					}
				},
				async handleProfileSave() {
					// 昵称必填
					if (!this.profileForm.nickname.trim()) {
						this.$message.warning('昵称不能为空')
						return
					}
					// 手机号校验
					if (this.profileForm.mobile && !/^1[3-9]\d{9}$/.test(this.profileForm.mobile)) {
						this.$message.warning('手机号格式不正确')
						return
					}
					// 邮箱校验
					if (this.profileForm.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.profileForm.email)) {
						this.$message.warning('邮箱格式不正确')
						return
					}
					// 密码校验
					if (this.profileForm.password) {
						if (this.profileForm.password.length < 6) {
							this.$message.warning('新密码至少6位')
							return
						}
						if (this.profileForm.password !== this.profileForm.confirm_password) {
							this.$message.warning('两次输入的密码不一致')
							return
						}
					}
					this.profileSaving = true
					try {
						const data = {
							nickname: this.profileForm.nickname.trim(),
							mobile: this.profileForm.mobile.trim(),
							email: this.profileForm.email.trim()
						}
						if (this.profileForm.password) {
							data.old_password = this.profileForm.old_password
							data.password = this.profileForm.password
						}
						const res = await adminApi.editProfile(data)
						if (res.code === 1) {
							// 更新本地缓存
							if (res.data && res.data.userinfo) {
								this.currentUser = res.data.userinfo
								localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo))
							}
							this.$message.success('保存成功')
							this.showProfileModal = false
							this.resetProfileForm()
						} else {
							this.$message.error(res.msg || '保存失败')
						}
					} catch (e) {
						this.$message.error(e.message || '保存失败')
					} finally {
						this.profileSaving = false
					}
				},
				async handleLogout() {
				try {
					await adminApi.logout()
				} catch (error) {
					console.error(error)
				} finally {
					this.stopCcPolling()
					this.ccNotifiedIds = []
					try {
						localStorage.removeItem('ccNotifiedIds')
					} catch (e) {}
					localStorage.removeItem('token')
					localStorage.removeItem('userinfo')
					this.$message.success('退出登录成功')
					this.$router.push('/login')
				}
			},
		// ========== 抄送待办轮询与提醒 ==========
		saveCcNotifiedIds() {
			try {
				// 用 Set 去重再持久化
				const ids = Array.from(new Set(this.ccNotifiedIds || []))
				this.ccNotifiedIds = ids
				localStorage.setItem('ccNotifiedIds', JSON.stringify(ids))
			} catch (e) {
				console.warn('保存 ccNotifiedIds 失败:', e)
			}
		},
		// 将当前所有待抄收的 production_id 标记为已查看/已通知
		markCurrentPendingAsNotified() {
			if (!this.ccPendingList || this.ccPendingList.length === 0) return
			const ids = this.ccPendingList.map(i => i.production_id).filter(v => v)
			if (ids.length > 0) {
				this.ccNotifiedIds = Array.from(new Set([...(this.ccNotifiedIds || []), ...ids]))
				this.saveCcNotifiedIds()
			}
		},
		startCcPolling() {
			// 幂等保护：已存在定时器则直接返回
			if (this.ccPollingTimer) return
			// 每30秒轮询一次
			this.ccPollingTimer = setInterval(() => {
				if (localStorage.getItem('token')) {
					this.loadCcPendingList()
				}
			}, 30000)
		},
		stopCcPolling() {
			if (this.ccPollingTimer) {
				clearInterval(this.ccPollingTimer)
				this.ccPollingTimer = null
			}
		},
		async loadCcPendingList() {
			try {
				// 一次拉取前100条（足够显示全部待办）
				const res = await productionApi.ccList(1, 100, '0', '')
				if (res.code === 1) {
					const newList = (res.data.list || []).map(item => ({
						...item,
						create_time: this.formatCcTime(item.createtime || item.create_time)
					}))
					this.ccPendingCount = res.data.total || 0
					this.ccPendingList = newList
					// 存在未处理且有"新增"的待办（未通知过的）才弹窗
					if (newList.length > 0) {
						const productionIds = newList.map(i => i.production_id).filter(v => v)
						const hasNew = productionIds.some(id => !this.ccNotifiedIds.includes(id))
						// 仅在检测到新增待办时弹窗提醒；若用户已通过点击待办/稍后处理等方式处理过，则不再重复弹窗
						if (hasNew && !this.showCcReminderModal) {
							this.showCcReminderModal = true
							// 将本轮已展示的所有待办 production_id 加入已通知集合（持久化）
							this.ccNotifiedIds = Array.from(new Set([...(this.ccNotifiedIds || []), ...productionIds]))
							this.saveCcNotifiedIds()
						}
					}
				}
			} catch (e) {
				console.log('抄送轮询失败:', e)
			}
		},
		formatCcTime(t) {
			if (!t) return '-'
			const s = String(t).trim()
			// 已经是 YYYY-MM-DD HH:mm:ss 格式（后端已格式化），直接返回
			if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(s)) {
				return s.replace('T', ' ')
			}
			// 兼容纯数字时间戳（秒级10位/毫秒级13位）
			const num = Number(s)
			if (!isNaN(num) && s !== '') {
				const ts = s.length === 13 ? num : num * 1000
				const d = new Date(ts)
				if (!isNaN(d.getTime())) {
					const pad = n => String(n).padStart(2, '0')
					return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
				}
			}
			return s
		},
		handleCcReminderConfirm() {
			// 批量确认全部待抄收
			if (!this.ccPendingList || this.ccPendingList.length === 0) {
				this.showCcReminderModal = false
				return
			}
			this.$confirm({
				title: '确认全部抄收',
				content: `确认将当前列表中 ${this.ccPendingList.length} 条待抄收订单全部标记为已抄收？`,
				okText: '确认',
				cancelText: '取消',
				onOk: async () => {
					try {
						const tasks = this.ccPendingList.map(item => productionApi.ccConfirm(item.id))
						const results = await Promise.all(tasks)
						const successCount = results.filter(r => r.code === 1).length
						this.$message.success(`已完成 ${successCount}/${this.ccPendingList.length} 条抄收确认`)
						this.showCcReminderModal = false
						await this.loadCcPendingList()
					} catch (e) {
						this.$message.error('批量确认失败')
					}
				}
			})
		},
		// 用户点击“稍后处理”时，只关闭弹窗，将当前待办标记为已查看，之后只在 badge 显示数量，不再弹窗
		handleCcReminderCancel() {
			this.markCurrentPendingAsNotified()
			this.showCcReminderModal = false
		},
		async handleCcSingleConfirm(record) {
			try {
				const res = await productionApi.ccConfirm(record.id)
				if (res.code === 1) {
					this.$message.success('确认成功')
					// 从列表中移除该条，避免重复确认
					this.ccPendingList = this.ccPendingList.filter(i => i.id !== record.id)
					this.ccPendingCount = Math.max(0, this.ccPendingCount - 1)
					// 刷新一遍以保持数据同步
					await this.loadCcPendingList()
				} else {
					this.$message.error(res.msg || '确认失败')
				}
			} catch (e) {
				this.$message.error('确认失败')
			}
		},
		handleGoCcList() {
			// 点击铃铛/下拉菜单跳转待抄收页面时：
			// 将当前所有待办标记为已查看（已通过 header 入口看到），之后不再弹窗，仅保留 badge 数量
			this.markCurrentPendingAsNotified()
			this.showCcReminderModal = false
			this.$router.push({
				name: 'ccOrderList'
			})
		}
	}
}
</script>

<style scoped>
.enterprise-name {
	margin-right: 24px;
	font-size: 14px;
	color: #1890ff;
}

.enterprise-name i {
	margin-right: 6px;
}

.logo {
	height: 32px;
	margin: 16px;
	background: rgba(255, 255, 255, 0.2);
	text-align: center;
	line-height: 32px;
	color: white;
	font-weight: bold;
	border-radius: 4px;
}

.username-text {
	display: inline-block;
	padding: 0 4px;
}

.notification-btn {
	font-size: 18px;
	color: #1890ff;
}

.notification-btn:hover {
	background: #e6f7ff !important;
}
</style>